import { render } from "./Tc.vue?vue&type=template&id=b5a16caa"
import script from "./Tc.vue?vue&type=script&lang=js"
export * from "./Tc.vue?vue&type=script&lang=js"

import "./Tc.vue?vue&type=style&index=0&id=b5a16caa&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__